import request from '@/libs/request'

//投入品库存记录 列表
export function plantThingsStockLogListApi (data) {
  return request({
    url: `plant/plantThingsStockLog`,
    method: 'get',
    params: data
  })
}

//投入品库存记录 详情
export function plantThingsStockLogInfoApi (id) {
  return request({
    url: `plant/plantThingsStockLog/` + id,
    method: 'get'
  })
}


//投入品库存记录 编辑/添加
export function plantThingsStockLogSaveApi (data) {
  return request({
    url: `plant/plantThingsStockLog`,
    method: 'post',
    data: data
  })
}

//投入品库存记录 删除
export function plantThingsStockLogDelApi (id) {
  return request({
    url: `plant/plantThingsStockLog/` + id,
    method: 'delete'
  })
}

